import { render } from "./InputImage.vue?vue&type=template&id=c7951a48&scoped=true&ts=true"
import script from "./InputImage.vue?vue&type=script&lang=ts"
export * from "./InputImage.vue?vue&type=script&lang=ts"

import "./InputImage.vue?vue&type=style&index=0&id=c7951a48&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7951a48"]])

export default __exports__